import React, {Suspense} from 'react';
import {useSetRecoilState} from 'recoil';
import {useLocation, useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

import CommunityContents from './Contents';
import Loader from '../../components/common/Loader';
import ContentsHeader from '../../layouts/ContentsHeader';
import {OpeningModalStatus, isOpenContentsModal} from '../../store';
import Layout from '../../layouts';

export default function CommunityContentsWrapper() {
  const navigator = useNavigate();
  const location = useLocation();
  const setOpenModal = useSetRecoilState(isOpenContentsModal);
  const setOpeningModalStatus = useSetRecoilState(OpeningModalStatus);
  const toggleModal = async () => {
    setOpeningModalStatus('contents-report');
    setOpenModal(true);
  };
  const {t} = useTranslation(['views'], {
    keyPrefix: 'community.ContentsWrapper',
  });
  return (
    <Layout.Main>
      <div>
        <ContentsHeader
          txt={t('header')}
          isOption="community"
          clickOption={() => toggleModal()}
          back={() => {
            if (location.state?.prev) {
              navigator(`/${location.state.prev}`, {
                state: {
                  id: location.state?.id,
                  prev: location.state?.postPrev,
                },
              });
            } else {
              navigator(-1);
            }
          }}
        />
        <Suspense fallback={<Loader />}>
          <CommunityContents />
        </Suspense>
      </div>
    </Layout.Main>
  );
}
